import { Link, NavLink, useLocation } from "react-router-dom";
import { Activity } from "lucide-react";
import { useT } from "@/lib/i18n";

const SETTINGS_TABS = [
  ["clinic", "Perfil clínico"], ["appearance", "Aparência"], ["report", "Relatório"], ["ai", "IA"], ["assess", "Avaliação"],
  ["billing", "Plano"], ["legal", "Termos e Condições"], ["integrations", "Integrações"],
];
const ADMIN_TABS = [["branding", "Branding"], ["content", "Conteúdo"], ["aicontrol", "Controlo IA"], ["admin", "Terapeutas"]];

// Logótipo MIO: botão de regresso ao Painel Clínico (navegação interna, sem recarregar).
export function BrandLink({ name, tagline, logo, size = "sidebar", onClick, testId }) {
  const big = size === "header";
  return (
    <Link to="/" onClick={onClick} data-testid={testId} aria-label="Ir para o Painel Clínico" title="Painel Clínico"
      className={`mio-logo group flex items-center gap-3 min-w-0 ${big ? "px-2 py-1 -mx-2" : "p-2 -m-2"}`}>
      {!big && (
        <div className="w-10 h-10 shrink-0 rounded-xl bg-sky-500/10 border border-sky-500/40 flex items-center justify-center glow-sky overflow-hidden">
          {logo ? <img src={logo} alt={name} className="w-full h-full object-contain" /> : <Activity className="w-5 h-5 text-sky-400" strokeWidth={1.5} />}
        </div>
      )}
      <div className="min-w-0">
        <div className={`mio-letters font-display font-semibold truncate ${big ? "text-xl sm:text-2xl md:text-3xl tracking-[0.18em]" : "text-lg tracking-[0.2em]"}`}>{name}</div>
        <div className={`text-slate-500 tracking-wide truncate ${big ? "text-[10px] sm:text-[11px] md:text-xs mt-0.5" : "text-[9px] leading-tight max-w-[11rem] whitespace-normal"}`}>{tagline}</div>
      </div>
    </Link>
  );
}

// Lista de navegação partilhada (barra lateral e menu móvel), com submenus das Definições.
export function NavList({ items, isAdmin, onNavigate }) {
  const tx = useT();
  const { pathname, search } = useLocation();
  const tab = new URLSearchParams(search).get("tab") || "clinic";
  const sub = [...SETTINGS_TABS, ...(isAdmin ? ADMIN_TABS : [])];
  return (
    <nav className="px-3 py-2 space-y-1" aria-label="Navegação principal">
      {items.map((item) => (
        <div key={item.to}>
          <NavLink to={item.to} end={item.to === "/"} data-testid={item.testId} onClick={onNavigate}
            className={({ isActive }) => `group flex items-center gap-3 px-4 py-3 min-h-[44px] rounded-xl text-sm transition-colors ${
              isActive ? "bg-sky-500/10 text-sky-300 border border-sky-500/30 glow-sky" : "text-slate-400 hover:text-slate-100 hover:bg-slate-900/60 border border-transparent"}`}>
            <item.icon className="w-[18px] h-[18px]" strokeWidth={1.5} />
            <span className="font-medium">{item.label || tx(item.labelKey)}</span>
          </NavLink>
          {item.to === "/settings" && pathname.startsWith("/settings") && (
            <div className="mt-1 ml-6 pl-3 border-l border-slate-800 space-y-0.5" data-testid="nav-settings-submenu">
              {sub.map(([k, label]) => (
                <Link key={k} to={`/settings?tab=${k}`} onClick={onNavigate} data-testid={`nav-settings-${k}`}
                  className={`block px-3 py-2 rounded-lg text-[13px] transition-colors ${tab === k ? "text-sky-300 bg-sky-500/10" : "text-slate-500 hover:text-slate-200"}`}>
                  {label}
                </Link>
              ))}
            </div>
          )}
        </div>
      ))}
    </nav>
  );
}
